import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M14.5 31.5v-15h11.83a4.283 4.283 0 0 0-.018 1.5H16.154L24 23l3.611-2.304c.176.165.363.315.561.447.198.133.405.251.622.355L24 24.558l-8-5.116v10.25a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h15.385a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22v-7.668c.287-.064.554-.149.8-.254.248-.105.48-.234.7-.386V31.5zM31 20.135a2.651 2.651 0 0 1-1.947-.803 2.651 2.651 0 0 1-.803-1.947c0-.763.268-1.412.803-1.948A2.652 2.652 0 0 1 31 14.636c.763 0 1.412.267 1.947.803.535.535.803 1.184.803 1.947 0 .762-.268 1.412-.803 1.947a2.651 2.651 0 0 1-1.947.803Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M24 46.5c12.426 0 22.5-10.074 22.5-22.5S36.426 1.5 24 1.5 1.5 11.574 1.5 24 11.574 46.5 24 46.5m0 1.5c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }